import { KeyboardAvoidingView, View, FlatList, StyleSheet } from "react-native";
import FirmItem from "./FirmItem";
import { defined } from "react-native-reanimated";

function FirmList(props) {
  return (
    <KeyboardAvoidingView behavior="padding" style={styles.firmContainer}>
      <FlatList
        data={props.data}
        renderItem={(itemData) => {
          return (
            <FirmItem
              item={itemData.item}
              id={itemData.item.firmID}
              noaddr={props.noaddr}
              onPressFirm={props.onPressFirm}
            />
          );
        }}
        keyExtractor={(item, index) => {
          return item.firmID;
        }}
        alwaysBounceVertical={false} // only for ios
      />
    </KeyboardAvoidingView>
  );
}

export default FirmList;

const styles = StyleSheet.create({
  firmContainer: {
    flex: 5,
    paddingHorizontal: 10,
  },
});
